import browserHistory from '~/history';
import { useCanPostShifts, useUserSelector } from '~/hooks';
import { POSTHOG_EVENTS, trackPosthogEvent } from '~/services/posthog';
import { EmptyScreen } from '../../../../commonComponents/EmptyScreen/EmptyScreen';
import { getEmptyFilteredScreen } from '../utils';

export const EmptyMessage = ({ type }) => {
  const { title, description, Icon, buttonLink, buttonText } = getEmptyFilteredScreen(type);
  const canPostShifts = useCanPostShifts();
  const user = useUserSelector();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 300,
      }}
    >
      <EmptyScreen
        Icon={Icon}
        title={title}
        description={description}
        buttonText={buttonText}
        {...(canPostShifts && {
          onButtonClick: () => {
            trackPosthogEvent(POSTHOG_EVENTS.OFFICE_EMPTY_STATE_SHIFT_REQUEST_CLICKED);
            browserHistory.push(buttonLink);
          },
        })}
      />
    </div>
  );
};
